export enum CookieKey {
  REQUEST_EXECUTOR_CALL = 'request_executor_call',
  ONBOARDING_EVENT_TRACKING = 'onboarding_event_tracking',
  ONBOARDING_STANDARD_EVENT_TRACKING = 'onboarding_standard_event_tracking'
}
